<template>
    <div>
        <!-- Start Headers -->
        <header class="header">
            <!-- Top Header -->
            <div class="top-header">
                <div class="container">
                    <div class="row" v-bind:class="{ 'rtl': rtl}">
                        <div class="col-md-4 mobile-hide">
                            <p v-if="lang === 'ar'">رضا العملاء أهم أولوياتنا! </p>
                            <p v-else>Customer Satisfaction is always priority!</p>
                        </div>
                        <div class="col-md-3 col-5">
                            <div class="langs">
                                <a href="#" @click="setLanguage('ar')">العربية</a> &nbsp;|&nbsp; <a href="#" @click="setLanguage('en')">English</a>
                            </div>
                        </div>
                        <div class="col-md-5 col-7" >
                            <div class="langs">
<!--                                {{countries}}-->
                                <img v-if="lang === 'en'" :src="'/static/images/flags/'+countryMain+'.png'" style="border: solid white 1px; height: 30px; float:right; margin-right: 48px; margin-top: 5px;" />
                                <select v-if="lang === 'en'" @change="setCountryMain()" v-model="countryMain" style="font-weight: bolder; margin-right: 2px; float: right; margin-top: 5px; padding: 5px;">
                                    <option v-for="country in countries"  v-bind:value="country.id">{{country.name}}</option>
                                </select>
                                <img v-if="lang === 'ar'" :src="'/static/images/flags/'+countryMain+'.png'" style="border: solid white 1px; height: 30px; float:left; margin-left: 10px; margin-top: 5px;" />
                                <select v-if="lang === 'ar'" @change="setCountryMain()" v-model="countryMain" style="font-weight: bolder; margin-left: 2px; float: left; margin-top: 5px; padding: 5px;">
                                    <option v-for="country in countriesArabic"  v-bind:value="country.id">{{country.name}}</option>
                                </select>
                            </div>
<!--                            <ul class="top-menu">-->
<!--                                <li><a v-if="lang === 'ar'" href="http://www.universalcsc.com/ar/About.aspx"> عن الشركة</a><a v-else href="http://www.universalcsc.com/About.aspx">About Us</a></li>-->
<!--                                <li><a v-if="lang === 'ar'" href="http://www.universalcsc.com/ar/LocalProducts.aspx">علاماتنا التجارية</a><a v-else href="http://www.universalcsc.com/LocalProducts.aspx">Our Brands</a></li>-->
<!--                                <li><a v-if="lang === 'ar'" href="http://www.universalcsc.com/ar/Career.aspx"> التوظيف</a><a v-else href="http://www.universalcsc.com/Career.aspx">Careers</a></li>-->
<!--                                <li><a v-if="lang === 'ar'" href="http://www.universalcsc.com/ar/Contact.aspx">اتصل بنا</a><a v-else href="http://www.universalcsc.com/Contact.aspx">Contact Us</a></li>-->
<!--                            </ul>-->
                        </div>
                    </div>
                </div>
            </div>
            <!-- middle nav -->
            <div class="middle-nav">
                <div class="container">
                    <div class="row">
                        <ul class="col-md-12" v-bind:class="{ 'rtl': rtl}">
                            <div class="middle-links">
                                <router-link to="/" class="header-brand"><img src="/static/logo.jpg" alt="brand"></router-link>
                                <button id="mobile-nav" class="menu-btn"><i class="fas fa-bars"></i></button>
                                <a v-if="countryMain === 1" href="http://www.universalcsc.com/Branches.aspx" class="middle-link mobile-hide" target="_blank">
                                    <icon name="map-marker" scale="2"></icon> &nbsp;
                                    <span v-if="lang === 'ar'">الفروع</span> <span v-else>Our Branches</span>
                                </a>
                                <a v-if="countryMain === 19" href="https://goo.gl/maps/siZqkdb5p36sHgha6" class="middle-link mobile-hide" target="_blank">
                                    <icon name="map-marker" scale="2"></icon> &nbsp;
                                    <span v-if="lang === 'ar'">الفروع</span> <span v-else>Our Branches</span>
                                </a>

                                <div  style="min-width: 175px;">
                                    &nbsp;
                                </div>
                                <form class="mobile-hide">
                                    <div class="custom-search"> <button type="submit"><i class="fas fa-search"></i></button>
<!--                                        <input v-if="lang === 'ar'" class="form-control" type="text" placeholder="ابحث عن اسم الصنف...">-->
<!--                                        <input v-else class="form-control" type="text" placeholder="Search Products..">-->

                                    </div>
                                </form>
                                <router-link v-if="!auth" to="/register" class="middle-link mobile-hide">
                                    <span v-if="lang === 'ar'" >تسجيل</span>
                                    <span v-else>Register</span>
                                </router-link>
                                <router-link v-if="!auth" to="/login"  class="middle-link mobile-hide">
                                    <span v-if="lang === 'ar'" >تسجيل الدخول</span>
                                    <span v-else>Login &nbsp;</span>
                                </router-link>
                                <router-link v-if="auth" to="/dashboard"  class="middle-link mobile-hide">
                                    <span v-if="lang === 'ar'">حسابي</span>
                                    <span v-else>My Account</span>
                                </router-link>
                                <router-link v-if="auth" to="/login"  class="middle-link mobile-hide">
                                    <span v-if="lang === 'ar'" @click="onLogout">الخروج</span>
                                    <span v-else @click="onLogout">Logout</span>
                                </router-link>


<!--                                <router-link v-bind:class="{ 'middle-link2': rtl}" to="/website" class="mobile-hide">-->
<!--                                    <div class="shopping-cart ">-->
<!--                                        <img src="/static/images/icons/shopping.png" alt="shopping">-->
<!--                                        <span class="number">0</span>-->
<!--                                        <span class="price">0.00 <span v-if="lang === 'ar'" >ريال</span><span v-else>SR</span></span>-->
<!--                                    </div>-->
<!--                                </router-link>-->
                            </div>
                            <ul class="mobile-nav slide-in-top">
                                <li class="mob-list"><router-link to="/">
                                    <span v-if="lang === 'ar'">الرئيسية</span>
                                    <span v-else>Home</span>
                                </router-link></li>

                                <li class="mob-list"><router-link v-if="!auth" to="/register" >
                                    <span v-if="lang === 'ar'" >تسجيل</span>
                                    <span v-else>Register</span>
                                </router-link></li>
                                <li class="mob-list"><router-link v-if="!auth" to="/login" >
                                    <span v-if="lang === 'ar'" >تسجيل الدخول</span>
                                    <span v-else>Login</span>
                                </router-link></li>
                                <li class="mob-list"><router-link v-if="auth" to="/dashboard" >
                                    <span v-if="lang === 'ar'">حسابي</span>
                                    <span v-else>My Account</span>
                                </router-link></li>
                                <li class="mob-list"><router-link v-if="auth" to="/login">
                                    <span v-if="lang === 'ar'" @click="onLogout">الخروج</span>
                                    <span v-else @click="onLogout">Logout</span>
                                </router-link></li>
<!--                                <li id="drop-menu">-->
<!--                                    <span v-if="lang === 'ar'">الاقسام</span>-->
<!--                                    <span v-else>Categories</span>-->
<!--                                    <ul class="dropdown swing-in-bottom-fwd">-->
<!--                                        <li class="mob-list"><a href="http://www.universalcsc.com/LocalProducts.aspx?Category=1">-->
<!--                                            <span v-if="lang === 'ar'">غذائية</span>-->
<!--                                            <span v-else>GROCERY</span>-->
<!--                                        </a></li>-->
<!--                                        <li class="mob-list"><a href="http://www.universalcsc.com/LocalProducts.aspx?Category=20">-->
<!--                                            <span v-if="lang === 'ar'">الطازج</span>-->
<!--                                            <span v-else>FRESH</span>-->
<!--                                        </a></li>-->
<!--                                        <li class="mob-list"><a href="http://www.universalcsc.com/LocalProducts.aspx?Category=22">-->
<!--                                            <span v-if="lang === 'ar'">المجمدات</span>-->
<!--                                            <span v-else>FROZEN</span>-->
<!--                                        </a></li>-->
<!--                                        <li class="mob-list"><a href="http://www.universalcsc.com/PrimeProducts.aspx?Category=14">-->
<!--                                            <span v-if="lang === 'ar'">مشروبات وحلويات</span>-->
<!--                                            <span v-else>BEVERAGE</span>-->
<!--                                        </a></li>-->
<!--                                        <li class="mob-list"><a href="http://www.universalcsc.com/PrimeProducts.aspx?Category=32">-->
<!--                                            <span v-if="lang === 'ar'">الصحة والجمال</span>-->
<!--                                            <span v-else>HEALTH & BEAUTY</span>-->
<!--                                        </a></li>-->
<!--                                        <li class="mob-list"><a href="http://www.universalcsc.com/PrimeProducts.aspx?Category=32">-->
<!--                                            <span v-if="lang === 'ar'">عناية المنزل </span>-->
<!--                                            <span v-else>HOMECARE</span>-->
<!--                                        </a></li>-->
<!--                                        <li class="mob-list"><router-link to="/waffir">-->
<!--                                            <span v-if="lang === 'ar'">بطاقة وافر</span>-->
<!--                                            <span v-else>WAFFIR</span>-->
<!--                                        </router-link></li>-->
<!--                                    </ul>-->
<!--                                </li>-->
                            </ul>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- Mobile Search -->
            <div class="container mobile-search-cont">
                <div class="row">
                    <div class="col-8">
                        <form class="mobile-search">
                            <div class="custom-search"><button type="submit"><i class="fas fa-search"></i></button>
                                <input v-if="lang === 'ar'" class="form-control" type="text" placeholder="ابحث عن اسم الصنف...">
                                <input class="form-control" type="text" placeholder="Search Products..">
                            </div>
                        </form>
                    </div>
                    <div class="col-2">
                        <div class="shopping-cart ">
                            <img src="/static/images/icons/shopping.png" alt="shopping">
                            <span class="number">0</span>
                            <span class="price">0.00 <span v-if="lang === 'ar'" >ريال</span><span v-else>SR</span></span>
                        </div>
                    </div>
                </div>
            </div>

            <div>&nbsp;</div>
            <!-- last nav -->
<!--            <div class="last-nav mobile-hide">-->
<!--                <div class="container">-->
<!--                    <div class="row">-->
<!--                        <div class="col">-->
<!--                            <ul class="last-links">-->
<!--                            <li class="active" style="margin-right: 15px;">-->
<!--                                <router-link to="/">-->
<!--                                    <div class="last-icon"><img src="/static/images/icons/home.png" /></div>-->
<!--                                    <span v-if="lang === 'ar'">الرئيسية</span>-->
<!--                                    <span v-else>Home</span>-->
<!--                                </router-link>-->
<!--                            </li>-->
<!--                            <li>-->
<!--                                <a href="http://www.universalcsc.com/LocalProducts.aspx?Category=1" style="margin-right: 15px;">-->
<!--                                    <div class="last-icon"><img src="/static/images/icons/grocery.png" /></div>-->
<!--                                    <span v-if="lang === 'ar'">غذائية</span>-->
<!--                                    <span v-else>GROCERY</span>-->
<!--                                </a>-->
<!--                            </li>-->
<!--                            <li style="margin-right: 15px;">-->
<!--                                <a href="http://www.universalcsc.com/LocalProducts.aspx?Category=20">-->
<!--                                    <div class="last-icon"><img src="/static/images/icons/FRESH.png" /></div>-->
<!--                                    <span v-if="lang === 'ar'">الطازج</span>-->
<!--                                    <span v-else>FRESH</span>-->
<!--                                </a>-->
<!--                            </li>-->
<!--                            <li style="margin-right: 15px;">-->
<!--                                <a href="http://www.universalcsc.com/LocalProducts.aspx?Category=22">-->
<!--                                    <div class="last-icon"><img src="/static/images/icons/frozen.png" /></div>-->
<!--                                    <span v-if="lang === 'ar'">المجمدات</span>-->
<!--                                    <span v-else>FROZEN</span>-->
<!--                                </a>-->
<!--                            </li>-->
<!--                            <li style="margin-right: 15px;">-->
<!--                                <a href="http://www.universalcsc.com/PrimeProducts.aspx?Category=14">-->
<!--                                    <div class="last-icon"><img src="/static/images/icons/BEVERAGE.png" /></div>-->
<!--                                    <span v-if="lang === 'ar'">مشروبات وحلويات</span>-->
<!--                                    <span v-else>BEVERAGE</span>-->
<!--                                </a>-->
<!--                            </li>-->
<!--                            <li style="margin-right: 15px;">-->
<!--                                <a href="http://www.universalcsc.com/PrimeProducts.aspx?Category=32">-->
<!--                                    <div class="last-icon"><img src="/static/images/icons/beauty.png" /></div>-->
<!--                                    <span v-if="lang === 'ar'">الصحة والجمال</span>-->
<!--                                    <span v-else>HEALTH & BEAUTY</span>-->
<!--                                </a>-->
<!--                            </li>-->
<!--                            <li style="margin-right: 15px;">-->
<!--                                <a href="http://www.universalcsc.com/PrimeProducts.aspx?Category=32">-->
<!--                                    <div class="last-icon"><img src="/static/images/icons/homecare.png" /></div>-->
<!--                                    <span v-if="lang === 'ar'">عناية المنزل </span>-->
<!--                                    <span v-else>HOMECARE</span>-->
<!--                                </a>-->
<!--                            </li>-->
<!--                            <li class="active-2">-->
<!--                                <router-link to="/waffir">-->
<!--                                    <div class="last-icon"><img src="/static/images/icons/waffir.png" /></div>-->
<!--                                    <span v-if="lang === 'ar'">بطاقة وافر</span>-->
<!--                                    <span v-else>WAFFIR</span>-->
<!--                                </router-link>-->
<!--                            </li>-->
<!--                        </ul>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
        </header>









<!--        <b-navbar toggleable="md" type="dark" variant="dark" fixed="top" style="height: 40px;">-->
<!--            <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>-->
<!--            <b-collapse is-nav id="nav_collapse">-->
<!--                <b-navbar-nav>-->
<!--                    <b-nav-item v-if="!auth" to="/" activeClass="active" exact><icon name="homepage"></icon> Homepage</b-nav-item>-->
<!--                    <b-nav-item v-if="!auth" to="/waffir" activeClass="active" exact><icon name="Waffir"></icon> Waffir</b-nav-item>-->
<!--                    <b-nav-item v-if="auth" to="/dashboard" activeClass="active" exact><icon name="dashboard"></icon> Dashboard</b-nav-item>-->
<!--                </b-navbar-nav>-->

<!--                &lt;!&ndash; Right aligned nav items &ndash;&gt;-->
<!--                <b-navbar-nav class="ml-auto">-->
<!--                    <b-nav-item v-if="!auth" to="/login" activeClass="active" exact right><icon name="sign-in"></icon>  Login</b-nav-item>-->
<!--                    <b-nav-item v-if="!auth" to="/register" activeClass="active" exact right><icon name="user-plus"></icon> Register</b-nav-item>-->
<!--                    <b-nav-item v-if="auth" @click="onLogout" to="#" activeClass="active" exact right><icon name="sign-out" scale="1.5" ></icon></b-nav-item>-->
<!--                </b-navbar-nav>-->
<!--            </b-collapse>-->
<!--        </b-navbar>-->
    </div>
</template>

<script>
    import {mixin} from '@/mixins/mixins';
    import {Form, Errors} from '@/components/validations/forms';
    import router from './../../router'
    export default {
        mixins: [mixin],
        // data () {
        //     return {
        //         //
        //     }
        // },

        data () {
            return {
                countryMain: null,
            }
            },
        computed: {
      auth () {
        return this.$store.getters['auth/isAuthenticated']
      },
      balance () {
        return this.$store.getters['account/getBalance']
      }
    },
    methods: {
        setCountryMain(){
            let countryMain = this.countryMain;
            this.$store.dispatch('environment/setCountryMain', {countryMain})
            this.countryMain = this.$store.getters['environment/getCountryMain'];
        },
    },

        created() {
            this.countryMain = this.$store.getters['environment/getCountryMain'];
        }

  }
</script>
<style>
    /*@import url("https://cdn.rtlcss.com/bootstrap/v4.2.1/css/bootstrap.min.css");*/
    @media only screen and (min-width: 550px) {
        .mobilex {
            display: none;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/header.vue